window.addEventListener('DOMContentLoaded', function () {
  var $ = window.jQuery;
  if (!$) return;

  // 1. 读产品 JSON
  var jsonEl = document.getElementById('ProductJson-leo');
  if (!jsonEl) return;

  var product = JSON.parse(jsonEl.textContent || '{}');
  var variants = product.variants || [];
  if (!variants.length) return;

  var productOptions = product.options || [];

  // 2. 当前选中的变体 & options 数组
  var current =
    product.selected_or_first_available_variant ||
    variants.find(function (v) { return v.available; }) ||
    variants[0];

  var selectedOptions = (current.options || []).slice();
  var optionCount = productOptions.length || selectedOptions.length;

  for (var i = 0; i < optionCount; i++) {
    if (!selectedOptions[i] && productOptions[i]) {
      selectedOptions[i] = productOptions[i].values[0] || '';
    }
  }

  // Dawn 的原生 variant-selects
  function triggerNativeChange(index, value) {
    var $fieldsets = $('variant-selects .product-form__input'); // 每次最新的
    var $fs = $fieldsets.eq(index);
    if (!$fs.length) return;

    $fs.find('input[type="radio"]').each(function () {
      var input = this;
      var iv = $.trim(String(input.value || ''));
      if (iv === value) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // money 格式化（用 cents）
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      if (window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // 从当前页面的 variant-selects 中同步已选中的值
  function syncSelectedOptionsFromDom() {
    var $fieldsets = $('variant-selects .product-form__input');

    $fieldsets.each(function (index) {
      var $checked = $(this).find('input[type="radio"]:checked');
      if ($checked.length) {
        selectedOptions[index] = $.trim(String($checked.val()));
      }
    });
  }

  // 3. Quantity 价格表逻辑（原来的逻辑，保持不动）
  var $qtyBlock = $('.custom-option-quantity');
  var qtyIndex = $qtyBlock.length
    ? parseInt($qtyBlock.data('option-index'), 10)
    : null;
  var $qtyRows = $qtyBlock.length ? $qtyBlock.find('.custom-option-item') : $();

  function updateQuantityTable() {
    if (!$qtyBlock.length || qtyIndex == null) return;

    var $rows = $qtyBlock.find('.custom-option-item');

    // 找出当前其它选项固定时的所有变体（不同 Quantity）
    var byQty = {}; // quantity(原始字符串) -> variant
    variants.forEach(function (v) {
      if (!v.options) return;

      var ok = true;
      for (var i = 0; i < optionCount; i++) {
        if (i === qtyIndex) continue;
        var pv = $.trim(String(v.options[i] || ''));
        var sv = $.trim(String(selectedOptions[i] || ''));
        if (sv && pv !== sv) { ok = false; break; }
      }
      if (!ok) return;

      var qStr = $.trim(String(v.options[qtyIndex] || ''));
      if (!byQty[qStr]) {
        byQty[qStr] = v; // 简单取第一条
      }
    });

    // 计算基准单价（用数量最小的那条）——原来的逻辑
    var baseQtyStr = null;
    Object.keys(byQty).forEach(function (qStr) {
      var qInt = parseInt(qStr, 10);
      if (isNaN(qInt)) return;
      if (baseQtyStr === null || qInt < parseInt(baseQtyStr, 10)) {
        baseQtyStr = qStr;
      }
    });

    var baseUnitCents = null;
    if (baseQtyStr !== null) {
      var baseVar = byQty[baseQtyStr];
      var baseQtyInt = parseInt(baseQtyStr, 10) || 1;
      baseUnitCents = baseVar.price / baseQtyInt;
    }

    // 填充每一行（原逻辑）
    $rows.each(function () {
      var $row   = $(this);
      var qStr   = $.trim(String($row.data('value')));
      var variant = byQty[qStr] || null;

      var $sale  = $row.find('[data-role="sale"]');
      var $total = $row.find('[data-role="total"]');
      var $unit  = $row.find('[data-role="unit"]');

      if (!variant) {
        // 当前 Size 下没有这个数量的变体，显示为占位
        $sale.text('—').removeClass('positive negative');
        $total.text('—');
        $unit.text('—');

        // 标记：这一行没有基础价
        $row.data('hasBase', false);
        $row.data('baseTotalCents', null);
        $row.data('baseUnitCents', null);
        $row.data('savePct', 0);
        $row.data('qtyInt', null);
        return;
      }

      var qtyInt = parseInt(qStr, 10) || 1;

      // Total Price（基础总价）
      $total.text(formatMoney(variant.price));

      // Unit Price（基础单价）
      var unitCents = variant.price / qtyInt;
      $unit.text('$' + (unitCents / 100).toFixed(2) + ' / Unit');

      // Save %（原来的折扣逻辑）
      var pct = 0;
      if (baseUnitCents) {
        var diff = (baseUnitCents - unitCents) / baseUnitCents * 100;
        pct = Math.round(diff);
        $sale.text(pct + '%').removeClass('positive negative');
        if (pct > 0) $sale.addClass('positive');
        else if (pct < 0) $sale.addClass('negative');
      } else {
        $sale.text('0%').removeClass('positive negative');
      }

      // 把基础价格 & 折扣缓存到 data，给“附加变体”使用
      $row.data('hasBase', true);
      $row.data('baseTotalCents', variant.price);
      $row.data('baseUnitCents', unitCents);
      $row.data('savePct', pct);
      $row.data('qtyInt', qtyInt);
    });
  }

  // -----------------------------
  // 4. 附加变体逻辑（extra-option-dropdown）
  // -----------------------------
  var $extraDropdowns = $('.extra-option-dropdown');

  // 工具：从 "$114.00" 解析出 11400（cents）
  function parseMoneyToCents(text) {
    var num = parseFloat(String(text).replace(/[^0-9.\-]/g, ''));
    if (isNaN(num)) return 0;
    return Math.round(num * 100);
  }

  // 读取当前所有附加变体的“每单位附加价”（cents）
  function getExtrasInfo() {
    var infos = [];
    $extraDropdowns.each(function () {
      var $dd    = $(this);
      var label  = $.trim($dd.find('.custom-option-label').text()); // Handle Color / Shape...
      var fieldId = label.replace(/\s+/g, '_');                      // Handle_Color / Handle_Shape

      var $act = $dd.find('.custom-option-item.is-active').first();
      if (!$act.length) return;

      var selectedLabel = $.trim(String($act.data('label') || ''));
      var priceStr      = $.trim(String($act.data('price') || ''));  // 比如 "0.5"
      var priceFloat    = parseFloat(priceStr);
      var priceCentsPerUnit = isNaN(priceFloat) ? 0 : Math.round(priceFloat * 100);

      infos.push({
        label: label,
        fieldId: fieldId,
        selectedLabel: selectedLabel,
        priceCentsPerUnit: priceCentsPerUnit
      });
    });
    return infos;
  }

  // 把附加变体的选中值写回隐藏 input 的 value
  function syncExtrasToHidden(extrasInfo) {
    extrasInfo.forEach(function (info) {
      var $hidden = $('#' + info.fieldId);
      if ($hidden.length) {
        $hidden.val(info.selectedLabel);
      }
    });
  }

  // 基于当前 Quantity 表的“基础价 + Save%”，叠加所有附加价，刷新每一行 Total/Unit
  function applyExtrasOnQuantityTable() {
    if (!$qtyBlock.length) return;

    var extrasInfo = getExtrasInfo();
    syncExtrasToHidden(extrasInfo);

    // 所有附加变体的“每单位总附加价”（cents）
    var sumExtraPerUnitCents = 0;
    extrasInfo.forEach(function (info) {
      if (info.priceCentsPerUnit > 0) {
        sumExtraPerUnitCents += info.priceCentsPerUnit;
      }
    });

    // 1）更新所有梯度行的 Total / Unit
    $qtyRows.each(function () {
      var $row = $(this);
      if (!$row.data('hasBase')) return; // 没变体的行直接跳过

      var baseTotal   = $row.data('baseTotalCents') || 0;
      var baseUnit    = $row.data('baseUnitCents')  || 0;
      var qtyInt      = $row.data('qtyInt')         || 1;
      var savePct     = $row.data('savePct')        || 0;
      var factor      = 1 - (savePct / 100);        // (1 - 折扣百分比)

      // 按你的公式：
      // 新总价 = 基础总价 + (1 - Save%) × Σ(data-price) × 数量
      // 新单价 = 基础单价 + (1 - Save%) × Σ(data-price)
      var extraUnitCents  = Math.round(sumExtraPerUnitCents * factor);
      var extraTotalCents = extraUnitCents * qtyInt;

      var newTotalCents = baseTotal + extraTotalCents;
      var newUnitCents  = baseUnit  + extraUnitCents;

      var $total = $row.find('[data-role="total"]');
      var $unit  = $row.find('[data-role="unit"]');

      $total.text(formatMoney(newTotalCents));
      $unit.text('$' + (newUnitCents / 100).toFixed(2) + ' / Unit');
    });

    // 2）更新每个附加项对应 hidden 的 add-price & 右侧总价
    var $activeRow = $qtyRows.filter('.is-active').first();
    if (!$activeRow.length || !$activeRow.data('hasBase')) {
      return;
    }

    var activeQtyInt  = $activeRow.data('qtyInt')   || 1;
    var activeSavePct = $activeRow.data('savePct')  || 0;
    var activeFactor  = 1 - (activeSavePct / 100);
    var activeBaseTotal = $activeRow.data('baseTotalCents') || 0;

    // 每个附加选项自身的加价写进对应 hidden 的 add-price
    extrasInfo.forEach(function (info) {
      var $hidden = $('#' + info.fieldId);
      if (!$hidden.length) return;

      var p = info.priceCentsPerUnit || 0;
      var extraUnitCents  = Math.round(p * activeFactor);
      var extraTotalCents = extraUnitCents * activeQtyInt;

      // 以美元写入 add-price
      $hidden.attr('add-price', (extraTotalCents / 100).toFixed(2));
    });

    // 所有附加变体（在当前数量下）的总加价
    var extraTotalAllCents = 0;
    $('input[add-price]').each(function () {
      var v = parseFloat($(this).attr('add-price'));
      if (!isNaN(v)) {
        extraTotalAllCents += Math.round(v * 100);
      }
    });

    var finalTotalCents = activeBaseTotal + extraTotalAllCents;

var fujiaprice = extraTotalAllCents / 100;
    ymqJq('.product-additional input').data('price', fujiaprice).change();

    // swatche-total-right 总价 = 当前数量的最终总价
    var $money = $('.swatche-total-right').first();
    if ($money.length) {
      $money.text(formatMoney(finalTotalCents));
    }
  }

  // 在每次 updateQuantityTable() 后调用：重新缓存基础价 + 套用附加变体
  function afterBaseTableUpdated() {
    // 这里基础价已经存在于 data（在 updateQuantityTable 里缓存过）
    applyExtrasOnQuantityTable();
  }

  // 4. 非 Quantity 的下拉交互（Size 之类）
  var $dropdowns = $('.custom-option-dropdown');

  function openDropdown($dd) {
    if ($dd.hasClass('is-open')) return;
    $dd.addClass('is-open');
    // $dd.find('.custom-option-toggle').attr('aria-expanded', 'true');
    // $dd.find('.custom-option-list').stop(true, true).slideDown(150);
  }
  function closeDropdown($dd) {
    if (!$dd.hasClass('is-open')) return;
    $dd.removeClass('is-open');
    // $dd.find('.custom-option-toggle').attr('aria-expanded', 'false');
    // $dd.find('.custom-option-list').stop(true, true).slideUp(150);
  }
  function closeAllDropdowns() {
    $dropdowns.each(function () { closeDropdown($(this)); });
  }

  $dropdowns.each(function () {
    var $dd   = $(this);
    var idx   = parseInt($dd.data('option-index'), 10);
    // var $tog  = $dd.find('.custom-option-toggle');
    var $cur  = $dd.find('.custom-option-current');
    var $items= $dd.find('.custom-option-item');

    // $tog.on('click', function (e) {
    //   e.stopPropagation();
    //   if ($dd.hasClass('is-open')) closeDropdown($dd);
    //   else { closeAllDropdowns(); openDropdown($dd); }
    // });

    $items.on('click', function (e) {
      e.stopPropagation();
      var $item = $(this);
      var val   = $.trim(String($item.data('value')));

      $cur.text(val);
      $items.removeClass('is-active');
      $item.addClass('is-active');
      closeDropdown($dd);

      selectedOptions[idx] = val;

      // 同步到原生 radio，让 Dawn 自己处理变体/库存/按钮
      triggerNativeChange(idx, val);

      // Size 改了之后，刷新数量价格表 + 套用附加价
      updateQuantityTable();
      afterBaseTableUpdated();
    });
  });

  // 5. Quantity 表点击交互（只同步选项 + 触发 Dawn）
  if ($qtyBlock.length && qtyIndex != null) {
    var $rows = $qtyBlock.find('.custom-option-item');

    $rows.on('click', function (e) {
      e.stopPropagation();
      var $row = $(this);
      var qVal = $.trim(String($row.data('value')));

      $rows.removeClass('is-active');
      $row.addClass('is-active');

      selectedOptions[qtyIndex] = qVal;

      // 同步到原生 Quantity radio
      triggerNativeChange(qtyIndex, qVal);

      // 数量选了之后再刷新一次价格表 + 套用附加价
      updateQuantityTable();
      afterBaseTableUpdated();
    });
  }

  // 6. 附加变体 extra-option-dropdown 的交互
  if ($extraDropdowns.length) {
    $extraDropdowns.each(function () {
      var $dd      = $(this);
      // var $toggle  = $dd.find('.custom-option-toggle');
      var $current = $dd.find('.custom-option-current');
      var $items   = $dd.find('.custom-option-item');

      function openExtra() {
        if ($dd.hasClass('is-open')) return;
        $dd.addClass('is-open');
        // $toggle.attr('aria-expanded', 'true');
        $dd.find('.custom-option-list').stop(true, true).slideDown(150);
      }

      function closeExtra() {
        if (!$dd.hasClass('is-open')) return;
        $dd.removeClass('is-open');
        // $toggle.attr('aria-expanded', 'false');
        $dd.find('.custom-option-list').stop(true, true).slideUp(150);
      }

      // $toggle.on('click', function(e) {
      //   e.stopPropagation();
      //   if ($dd.hasClass('is-open')) closeExtra();
      //   else openExtra();
      // });

      $items.on('click', function(e) {
        e.stopPropagation();
        var $item = $(this);
        var label = $.trim(String($item.data('label') || ''));

        $items.removeClass('is-active');
        $item.addClass('is-active');
        $current.text(label);
        closeExtra();

        // 只改附加变体，不动 base 表逻辑，只在当前基础价上叠加
        applyExtrasOnQuantityTable();
      });
    });
  }

  // 初始渲染价格表：用原逻辑 + 套用一次附加价
  syncSelectedOptionsFromDom();
  updateQuantityTable();
  afterBaseTableUpdated();

  // 点击空白处收起所有下拉（主变体 & 附加变体）
  // $(document).on('click', function (e) {
  //   if (!$(e.target).closest('.custom-option-dropdown, .extra-option-dropdown').length) {
  //     closeAllDropdowns();
  //     $extraDropdowns.each(function () {
  //       var $dd = $(this);
  //       if ($dd.hasClass('is-open')) {
  //         $dd.removeClass('is-open');
  //         $dd.find('.custom-option-toggle').attr('aria-expanded', 'false');
  //         $dd.find('.custom-option-list').stop(true, true).slideUp(150);
  //       }
  //     });
  //   }
  // });
});
